module.exports = __webpack_public_path__ + "media/images/flags/32/Iceland-241b06d074a529917be62cae42b147e8.png";